<template>
  <form class="row g-3 needs-validation" novalidate>
    <div class="row">
      <div class="alert alert-warning alert-dismissible fade show" style="margin: 10px" role="alert" v-if="sicad"><strong>Atenção !</strong> Atualize os dados do profissional no nosso sistema SICAD para concluir o cadastro.</div>
    </div>
    <div class="row" style="margin-top: 25px">
      <fieldset>
        <legend style="width: 160px">Dados Pessoais</legend>
        <div class="row">
          <div style="display: flex; flex-direction: column; max-width: 250px; max-height: 230px">
            <img class="rounded" alt="" id="imgFoto" style="flex: 1; object-fit: cover; max-width: 250px; max-height: 210px" />

            <input id="uploadImg" type="file" ref="uploadImg" v-on:change="uploadFileImg" />
            <a style="color: deepskyblue; text-align: center" id="upload_img" @click="openUploadImg" ref="uploadImgClick">Incluir foto</a>
          </div>
          <div class="col">
            <div class="row">
              <div class="col-12 col-md-12 col-lg-12 col-xl-9" style="padding: 0px 10px">
                <label for="nome" class="m-b-5">Nome completo</label>
                <input type="text" class="form-control form-input-component" v-model="formSicad.nome" id="nome" aria-describedby="nome" v-bind:class="{ 'is-invalid': submitted && formSicad.nome.length === 0 }" required disabled />
              </div>
              <div class="col-12 col-md-12 col-lg-12 col-xl-3" style="padding: 0px 10px">
                <label for="vinculo" class="m-b-5">Vínculo Profissional</label>
                <input type="text" class="form-control form-input-component" v-model="form.vinculo" aria-describedby="vinculo" id="vinculo" v-bind:class="{ 'is-invalid': submitted && form.vinculo.length === 0 }" required disabled />
              </div>
            </div>
            <div class="row" style="margin-top: 10px">
              <div class="col-12 col-md-12 col-lg-12 col-xl-9" style="padding: 0px 10px">
                <div class="row">
                  <div class="col-lg-6">
                    <label for="cpf" class="m-b-5">CPF</label>
                    <input type="text" class="form-control form-input-component" v-mask="'###.###.###-##'" v-model="form.cpf" ref="cpf" id="cpf" required v-bind:class="{ 'is-invalid': submitted && form.cpf.length === 0 }" @keyup="validarCpf" disabled />
                  </div>
                  <div class="col-6">
                    <label for="rgProfissional" class="m-b-5">RG Militar</label>
                    <input type="text" class="form-control form-input-component" v-model="formSicad.rgMilitar" id="rgMilitar" v-bind:class="{ 'is-invalid': submitted && !formSicad.rgMilitar }" required disabled />
                  </div>
                  <div class="col-12 col-md-12 col-lg-6 col-xl-6">
                    <label for="numeroRg" class="m-b-5">RG</label>
                    <input type="text" class="form-control form-input-component" v-model="formSicad.rgCivil" id="numeroRg" v-bind:class="{ 'is-invalid': submitted && !formSicad.rgCivil }" required disabled />
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-12 col-xl-3" style="padding: 0px 10px">
                <label for="situacao" class="m-b-5">Situação</label>
                <input type="text" class="form-control form-input-component" v-model="formSicad.status" id="situacao" v-bind:class="{ 'is-invalid': submitted && !formSicad.status.lenght === 0 }" required disabled />
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-12 col-lg-6 col-xl-6">
                <label for="telefoneCelular">Telefone Celular</label>
                <input type="text" v-model="form.telefoneCelular" v-mask="'(##) #####-####'" class="form-control form-input-component" id="telefoneCelular" v-bind:class="{ 'is-invalid': submitted && !form.telefoneCelular }" required />
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6">
                <label for="telefoneResidencial">Telefone Fixo</label>
                <input type="text" v-model="form.telefoneResidencial" v-mask="'(##) ####-####'" class="form-control form-input-component" id="telefoneResidencial" aria-required="false" />
              </div>
            </div>
          </div>
        </div>

        <div class="row" style="margin-top: 10px">
          <div class="col-12 col-md-12 col-lg-6 col-xl-4">
            <label for="naturalidade">Naturalidade</label>
            <input type="text" v-model="formSicad.naturalidade" class="form-control form-input-component" id="naturalidade" v-bind:class="{ 'is-invalid': submitted && !form.naturalidade }" required disabled />
          </div>
          <div class="col-12 col-md-12 col-lg-6 col-xl-4">
            <label>Estado Civil</label>
            <select class="form-select" v-model="form.estadoCivil" v-bind:class="{ 'is-invalid': submitted && !form.estadoCivil }" required>
              <option v-for="item in estadosCivis" :key="item.id" :value="item">
                {{ item.nome }}
              </option>
            </select>
          </div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-2">
            <label>Data Nascimento</label>
            <input type="text" v-model="formSicad.dtNascimento" class="form-control form-input-component" id="dtNascimento" v-mask="'##/##/####'" v-bind:class="{ 'is-invalid': submitted && !formSicad.dtNascimento }" required disabled />
          </div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-2">
            <label for="idade">Idade</label>
            <input type="number" v-model="formSicad.idade" class="form-control form-input-component" id="idade" v-bind:class="{ 'is-invalid': submitted && !formSicad.idade }" required disabled />
          </div>
        </div>

        <div class="row" style="margin-top: 10px">
          <div class="col-6">
            <label for="nomeMae">Nome da Mãe</label>
            <input type="text" class="form-control form-input-component" v-model="formSicad.nomeMae" v-bind:class="{ 'is-invalid': submitted && !formSicad.nomeMae }" id="nomeMae" aria-describedby="nomeMae" required disabled />
          </div>
          <div class="col-6">
            <label for="nomePai">Nome do Pai</label>
            <input type="text" class="form-control form-input-component" v-model="formSicad.nomePai" v-bind:class="{ 'is-invalid': submitted && !formSicad.nomePai }" id="nomePai" aria-describedby="nomePai" required disabled />
          </div>
        </div>
      </fieldset>
    </div>

    <div class="row" style="margin-top: 25px">
      <fieldset>
        <legend style="width: 220px">Endereço Residencial</legend>
        <div class="row" style="margin-top: 10px">
          <div class="col-12 col-md-9 col-lg-12 col-xl-6">
            <label for="logradouro">Logradouro</label>
            <input type="text" class="form-control form-input-component" id="logradouro" v-model="outForm.logradouro" v-bind:class="{ 'is-invalid': submitted && !outForm.logradouro }" aria-describedby="logradouro" required />
          </div>
          <div class="col-12 col-md-3 col-lg-4 col-xl-2">
            <label for="numero">Número</label>
            <input type="text" v-model="outForm.numero" class="form-control form-input-component" id="numero" required />
          </div>
          <div class="col-12 col-md-12 col-lg-8 col-xl-4">
            <label for="complemento">Complemento</label>
            <input type="text" class="form-control form-input-component" id="complemento" v-model="outForm.complemento" aria-describedby="complemento" />
          </div>
        </div>
        <div class="row" style="margin-top: 10px">
          <div class="col-12 col-xs-12 col-md-3 col-lg-3 col-xl-1">
            <label for="quadra">Quadra</label>
            <input type="text" v-model="outForm.quadra" class="form-control form-input-component" id="quadra" required />
          </div>
          <div class="col-12 col-xs-12 col-md-3 col-lg-3 col-xl-1">
            <label for="lote">Lote</label>
            <input type="text" v-model="outForm.lote" class="form-control form-input-component" id="lote" required />
          </div>
          <div class="col-12 col-xs-12 col-md-6 col-lg-6 col-xl-4">
            <label for="setor">Setor</label>
            <input type="text" v-model="outForm.setor" v-bind:class="{ 'is-invalid': submitted && !outForm.setor }" class="form-control form-input-component" id="setor" required />
          </div>
          <div class="col-12 col-xs-12 col-md-12 col-lg-5 col-xl-3">
            <label for="cidade">Cidade</label>
            <input type="text" class="form-control form-input-component" id="cidade" v-model="outForm.cidade" v-bind:class="{ 'is-invalid': submitted && !outForm.cidade }" aria-describedby="cidade" required />
          </div>
          <div class="col-12 col-xs-12 col-md-12 col-lg-3 col-xl-1">
            <label for="complemento">Estado</label>
            <input type="text" class="form-control form-input-component" id="estado" v-model="outForm.uf" v-bind:class="{ 'is-invalid': submitted && !outForm.uf }" aria-describedby="estado" required />
          </div>

          <div class="col-12 col-xs-12 col-md-12 col-lg-4 col-xl-2">
            <label for="cep">CEP</label>
            <input type="text" class="form-control form-input-component" id="cep" ref="cep" v-mask="'##.###-###'" @keyup="searchCep" v-model="outForm.cep" v-bind:class="{ 'is-invalid': submitted && $refs.cep.value.length === 0 }" required />
          </div>
        </div>
      </fieldset>
    </div>
    <div class="row" style="margin-top: 25px">
      <fieldset>
        <legend style="width: 220px">Dados Profissionais</legend>
        <div class="row" style="margin-top: 10px">
          <div class="col-6">
            <label for="email">E-mail</label>
            <input type="text" v-model="form.email" v-bind:class="{ 'is-invalid': submitted && !form.email }" ref="email" @keyup="validarEmail" class="form-control form-input-component" id="email" required />
          </div>
          <div class="col-6">
            <label>Data de Inclusão</label>
            <input type="text" v-model="formSicad.dtInclusao" class="form-control form-input-component" id="dtInclusao" v-bind:class="{ 'is-invalid': submitted && !formSicad.dtInclusao }" required disabled />
          </div>
        </div>
        <div class="row" style="margin-top: 10px">
          <div class="col-6">
            <label>Especialidade</label>
            <select class="form-select" v-model="form.especialidade" v-bind:class="{ 'is-invalid': submitted && !form.especialidade }" @change="getSubEspecialidades" required>
              <option v-for="item in especialidade" :key="item.especialidade.id" :value="item.especialidade">
                {{ item.especialidade.nome }}
              </option>
            </select>
          </div>
          <div class="col-6">
            <label>Subespecialidade</label>
            <select class="form-select" v-model="form.subEspecialidade">
              <option v-for="item in subEspecialidade" :key="item.id" :value="item">
                {{ item.nome }}
              </option>
            </select>
          </div>
        </div>

        <div class="row" style="margin-top: 10px">
          <div class="col">
            <label>Posto/Graduação</label>
            <select class="form-select" v-model="form.posto">
              <option v-for="item in postoGraduacao" :key="item.id" :value="item">{{ item.nome }} - {{ item.sigla }}</option>
            </select>
          </div>
          <div class="col">
            <label>Função Atual</label>
            <input type="text" class="form-control form-input-component" id="funcaoAtual" aria-describedby="funcaoAtual" required disabled />
          </div>
        </div>
        <div class="row" style="margin-top: 10px">
          <label class="form-check-inline" style="font-size: 14px; font-weight: bold">Convênio que atende:</label>
          <div class="row" style="margin: 0px !important; padding: 0px !important">
            <div class="col-6 form-check-item">
              <a-checkbox-group v-model:value="form.convenios" required>
                <a-checkbox value="IPASGO" name="type"><span v-bind:class="{ 'is-invalid-check-box': submitted && form.convenios.length == 0 }">Ipasgo</span></a-checkbox>
                <a-checkbox value="DOACAO" name="type"><span v-bind:class="{ 'is-invalid-check-box': submitted && form.convenios.length == 0 }">Doação</span></a-checkbox>
                <a-checkbox value="PARTICULAR" name="type"><span v-bind:class="{ 'is-invalid-check-box': submitted && form.convenios.length == 0 }">Particular</span></a-checkbox>
              </a-checkbox-group>
            </div>
            <div class="col-3">
              <label for="numeroConvenio">Número do Convênio</label>
              <input type="text" v-model="form.numeroConvenio" ref="numeroConvenio" class="form-control form-input-component" id="numeroConvenio" />
            </div>
            <div class="col-3">
              <label for="numeroConselho">Número de Conselho</label>
              <input type="text" class="form-control form-input-component" v-model="form.numeroConselho" v-bind:class="{ 'is-invalid': submitted && !form.numeroConselho }" id="numeroConselho" aria-describedby="numeroConselho" required />
            </div>
          </div>
        </div>

        <div class="row" style="margin-top: 10px; padding-top: 10px">
          <div class="col-4">
            <div class="row">
              <div class="col-12">
                <label for="formFileSm" class="form-label">Tipo Documento</label>
                <select class="form-select form-input-component" ref="tipoDocumento">
                  <option v-for="item in enumTipoDocumento" :key="item" :value="item.tipo">
                    {{ item.descricao }}
                  </option>
                </select>
              </div>
              <div class="col-12" style="margin-top: 10px">
                <label for="formFileSm" class="form-label">Importar Arquivo</label>
                <input class="form-control form-control-sm form-input-component" id="formFileSm" type="file" name="file" ref="files" multiple v-on:change="uploadFile" />
              </div>
            </div>
          </div>
          <div class="col-8" style="margin-top: 15px">
            <a-table :dataSource="dataDocuments" :columns="columns">
              <template #nomeArquivo="{ record }">
                <span>{{ record.nomeArquivo }}</span
                ><i class="far fa-file-alt" style="margin-left: 5px; cursor: pointer" @click="baixarArquivo(record)"></i>
              </template>
              <template #tipoDocumento="{ record }">
                <span>{{ stringTipoDocumento(record) }}</span>
              </template>
              <template #action="{ record }">
                <a @click="removeDataArchive(record)"><i class="fas fa-trash icon-trash"></i></a>
              </template>
              <template>
                <a-pagination :total="500" />
              </template>
            </a-table>
          </div>
        </div>
      </fieldset>
    </div>

    <div class="row justify-content-end" style="margin-top: 10px">
      <div class="col">
        <div class="float-end">
          <button type="button" class="btn btn-primary" @click="this.$router.push({ path: '/profissional-page' })">Voltar</button>&nbsp;
          <button type="button" class="btn btn-primary" @click="saveAndContinue(v$.form.$invalid)">Salvar e continuar</button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { downloadDocumentFileWs, isArquivoValido, loadDocumentFileWs, sendDocumentFileWs } from '@/utils/filews';
import { convertBase64ToBlob, domainPostoGraduacao, domainSubEspecialidade, imgToBase64, isEmail, searchCepService, validarCpf } from '@/utils/servicos-utils';
import { EnderecoModel } from '@/components/models/endereco';
import { EnumTipoDocumento } from '@/components/models/enumTipoDocumento';
import { createProfissional, getProfissionalById } from '@/components/service/profissionalService';
import loadGif from '../../../assets/load.gif';
import imgDoctor from '../../../assets/doutor.jpeg';
import { openNotification, typesNotification } from '@/utils/notifications';
import { useVuelidate } from '@vuelidate/core';
import { email, minLength, required } from '@vuelidate/validators';
import moment from 'moment';
import { domainEstadosCivisSicad, domainGrauEscolaridade, getUserByCpf } from '@/config/servicos-utils';
import router from '@/router';
import { getEspecialidades } from '@/components/service/especilidadeService';

export default {
  name: 'FormProfissionalMilitar',
  components: {},
  props: {
    idProf: {
      type: String,
      required: false,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      errors: [],
      dataDocuments: [],
      postoGraduacao: [],
      submitted: false,
      especialidade: [],
      subEspecialidade: [],
      enumTipoDocumento: [],
      funcoesAtivas: [],
      estadosCivis: [],
      grauEscolaridade: [],
      carregado: false,
      sicad: false,
      columns: [
        {
          title: 'Tipo Documento',
          dataIndex: 'tipoDocumento',
          key: 'tipoDocumento',
          slots: { customRender: 'tipoDocumento' },
        },
        {
          title: 'Arquivo',
          dataIndex: 'nomeArquivo',
          key: 'nomeArquivo',
          slots: { customRender: 'nomeArquivo' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
      form: {
        id: undefined,
        cpf: undefined,
        nome: undefined,
        idAnexoFileImg: undefined,
        telefoneCelular: '',
        telefoneResidencial: '',
        endereco: undefined,
        estadoCivil: undefined,
        grauEscolaridade: undefined,
        numeroConselho: undefined,
        email: undefined,
        vinculo: undefined,
        posto: undefined,
        especialidade: undefined,
        subEspecialidade: undefined,
        convenios: [],
        numeroConvenio: undefined,
        documentos: [],
        situacao: undefined,
        rgProfissional: undefined,
      },
      formSicad: {
        nome: undefined,
        dtNascimento: undefined,
        dtInclusao: undefined,
        rgCivil: undefined,
        rgMilitar: undefined,
        idade: undefined,
        naturalidade: undefined,
        nomeMae: undefined,
        nomePai: undefined,
      },
      outForm: {
        numero: undefined,
        complemento: undefined,
        logradouro: undefined,
        setor: undefined,
        cidade: undefined,
        uf: undefined,
        lote: undefined,
        quadra: undefined,
      },
    };
  },
  validations() {
    return {
      form: {
        cpf: {
          required,
          min: minLength(14),
        },
        nome: {
          required,
        },
        telefoneCelular: {
          required,
        },
        endereco: {
          required,
        },
        estadoCivil: {
          required,
        },
        numeroConselho: {
          required,
        },

        email: {
          required,
          email,
        },
        vinculo: {
          required,
        },
        especialidade: {
          required,
        },
      },
    };
  },
  async created() {
    await this.onInit();
  },
  methods: {
    router() {
      return router;
    },
    async onInit() {
      await this.getPostoGraduacao();
      await this.getEspecialidades();
      await this.getEstadosCivisSicad();
      await this.getGrauEscolaridade();
      this.getTipoDocumento();

      if (localStorage.getItem('cpf')) {
        let cpf = localStorage.getItem('cpf');
        this.form.cpf = cpf;
        await this.patchFormSicad(cpf.replace('-', '').replaceAll('.', ''));
        await this.patchForm(this.formSicad);
        localStorage.removeItem('cpf');
      } else {
        if ((this.$route.query.id && !this.carregado) || (this.idProf && !this.carregado)) {
          await getProfissionalById(this.$route.query.id ? this.$route.query.id : this.idProf).then(async (p) => {
            document.getElementById('imgFoto').src = loadGif;
            await this.patchFormSicad(p.data.cpf);
            this.form = p.data;
            this.form.documentos = p.data.documentos;
            await this.patchForm(p.data);
            this.carregado = true;
          });
        } else {
          document.getElementById('imgFoto').src = imgDoctor;
          this.$router.push('/profissional-page');
        }
      }
    },
    async patchFormSicad(cpf) {
      await getUserByCpf(cpf).then((r) => {
        this.formSicad = r.data;
        let dataNascimento = new Date(r.data.dtNascimento);
        let dataInclusao = new Date(r.data.dtInclusao);
        this.formSicad.dtNascimento = moment(dataNascimento).format('DD/MM/YYYY');
        this.formSicad.dtInclusao = moment(dataInclusao).format('DD/MM/YYYY');
      });
    },
    async uploadFile() {
      let validarTamanho = isArquivoValido('', '', this.$refs.files.files[0].size, true);
      if (this.$refs.tipoDocumento.value) {
        if (validarTamanho.tamanho) {
          await sendDocumentFileWs(this.$refs.files.files[0], 'TOKEN', 'ssp').then((r) => {
            const obj = {
              idAnexoFileWs: r.data.id,
              tipoDocumento: this.$refs.tipoDocumento.value,
              nomeArquivo: r.data.nomeOriginal,
            };
            this.dataDocuments.push(obj);
            openNotification(typesNotification.success, 'Arquivo enviado com sucesso');
          });
        } else {
          openNotification(typesNotification.error, 'Tamanho de arquivo não suportado.');
        }
      }
    },
    async searchCep() {
      if (this.$refs.cep.value.length === 10) {
        await searchCepService(this.$refs.cep.value.replace('.', '').replace('-', '')).then((r) => {
          if (r.data && r.data[0]) {
            this.outForm = {};
            this.form.endereco = EnderecoModel(r.data[0]);
            this.outForm.cep = this.$refs.cep.value;
            this.outForm.logradouro = EnderecoModel(r.data[0]).logradouro;
            this.outForm.setor = EnderecoModel(r.data[0]).bairro;
            this.outForm.cidade = EnderecoModel(r.data[0]).cidade;
            this.outForm.uf = EnderecoModel(r.data[0]).uf;
          }
        });
      }
    },
    removeDataArchive(record) {
      if (!this.form.id) {
        this.dataDocuments.splice(this.dataDocuments.indexOf(this.dataDocuments.find((r) => r.tipoDocumento === record.tipoDocumento && r.nomeArquivo === record.nomeArquivo)), 1);
      } else {
        this.form.documentos.splice(this.form.documentos.indexOf(this.form.documentos.find((r) => r.idAnexoFileWs === record.idAnexoFileWs)), 1);
        this.saveAndContinue();
      }
    },

    async getPostoGraduacao() {
      await domainPostoGraduacao().then((r) => (this.postoGraduacao = r.data));
      for (let p of this.postoGraduacao) {
        p.nome = p.nome.toUpperCase();
      }
    },

    async getEspecialidades() {
      await getEspecialidades().then((r) => (this.especialidade = r.data));
    },

    async getSubEspecialidades() {
      await domainSubEspecialidade(this.form.especialidade.id).then((r) => (this.subEspecialidade = r.data));
    },

    async getEstadosCivisSicad() {
      await domainEstadosCivisSicad().then((r) => (this.estadosCivis = r.data));
    },

    async getGrauEscolaridade() {
      await domainGrauEscolaridade().then((r) => (this.grauEscolaridade = r.data));
    },

    openUploadImg() {
      let button = document.getElementById('uploadImg');
      button.click();
    },
    async uploadFileImg() {
      let validos = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      let nomeArquivo = this.$refs.uploadImg.files[0].name;
      let tamanho = this.$refs.uploadImg.files[0].size;
      let valido = isArquivoValido(nomeArquivo, validos, tamanho);

      if (valido.tamanho && valido.extensoes)
        await sendDocumentFileWs(this.$refs.uploadImg.files[0], 'TOKEN', 'ssp').then(async (r) => {
          document.getElementById('imgFoto').src = await imgToBase64(this.$refs.uploadImg.files[0]);
          this.form.idAnexoFileImg = r.data.id;
        });
      else openNotification(typesNotification.error, 'Extensão ou tamanho de arquivo inválido.');
    },
    setConvencio(convenio) {
      switch (convenio) {
        case 'PARTICULAR':
          if (this.$refs.particular.checked) {
            this.form.convenios.push(convenio);
            this.$refs.particular.checked = false;
          } else {
            this.form.convenios.splice(this.form.convenios.indexOf(convenio), 1);
            this.$refs.particular.checked = false;
          }
          break;
        case 'DOACAO':
          if (this.$refs.doacao.checked) {
            this.form.convenios.push(convenio);
            this.$refs.doacao.checked = false;
          } else {
            this.form.convenios.splice(this.form.convenios.indexOf(convenio), 1);
            this.$refs.doacao.checked = false;
          }
          break;
        case 'IPASGO':
          if (this.$refs.ipasgo.checked) {
            this.form.convenios.push(convenio);
            this.$refs.ipasgo.checked = false;
          } else {
            this.form.convenios.splice(this.form.convenios.indexOf(convenio), 1);
            this.$refs.ipasgo.checked = false;
          }
          break;
        default:
          break;
      }
    },

    async saveAndContinue(valid) {
      this.submitted = valid || this.form.convenios.length == 0;
      await this.montarObjeto();
      if (!valid && this.form.convenios.length > 0) {
        this.form.cpf = this.form.cpf.replaceAll('.', '').replace('-', '');
        this.form.situacao = this.formSicad.status;
        await createProfissional(this.form).then((r) => {
          this.form.id = r.data.id;
          this.sicad = false;
          openNotification(typesNotification.success, 'Dados salvo com sucesso.');
          // if (back) {
          // 	this.$router.push({ path: '/profissional' });
          // }
        });
      } else {
        this.verificarDadosSicad();
        openNotification(typesNotification.warning, 'Preencher campos obrigatórios');
        return false;
      }
    },
    verificarDadosSicad() {
      if (!this.formSicad.rgCivil || !this.formSicad.naturalidade || !this.formSicad.dtNascimento || !this.formSicad.idade || !this.formSicad.nome) {
        this.sicad = true;
      }
    },
    async montarObjeto() {
      if (this.outForm.numero) {
        this.form.endereco.numero = this.outForm.numero;
      }
      if (this.outForm.setor) {
        this.form.endereco.bairro = this.outForm.setor;
      }
      if (this.outForm.complemento) {
        this.form.endereco.complemento = this.outForm.complemento;
      }
      this.form.documentos = this.dataDocuments;
    },
    getTipoDocumento() {
      this.enumTipoDocumento = EnumTipoDocumento();
    },
    validarCpf() {
      let value = this.$refs.cpf.value;
      this.$refs.cpf.classList.value = ['form-control'];
      if (!validarCpf(value)) {
        this.$refs.cpf.classList.value = ['form-control is-invalid'];
      }
    },
    validarEmail() {
      let value = this.$refs.email.value;
      this.$refs.email.classList.value = ['form-control'];
      if (!isEmail(value)) this.$refs.email.classList.value = ['form-control is-invalid'];
    },
    async patchForm(form) {
      this.form.nome = form.nome;
      this.form.vinculo = form.vinculo;
      this.form.email = form.email;
      this.form.telefoneCelular = form.telefoneCelular;
      this.form.telefoneResidencial = form.telefoneResidencial;
      this.form.posto = form.posto;
      this.form.rgCivil = this.formSicad.rgCivil;
      this.form.rgProfissional = this.formSicad.rgMilitar;

      if (this.formSicad.naturalidade) {
        this.formSicad.naturalidade = this.formSicad.naturalidade.nome + '-' + this.formSicad.naturalidade.uf;
        this.form.naturalidade = this.formSicad.naturalidade;
      }

      let funcaoAtiva = {};
      if (this.formSicad.funcoesAtivas && this.formSicad.funcoesAtivas.length > 1) {
        funcaoAtiva = this.formSicad.funcoesAtivas.find((fa) => fa.principal);
        if (!funcaoAtiva) {
          funcaoAtiva = this.formSicad.funcoesAtivas[0];
        }
      } else if (this.formSicad.funcoesAtivas && this.formSicad.funcoesAtivas.length === 1) {
        funcaoAtiva = this.formSicad.funcoesAtivas[0];
      }

      if (funcaoAtiva.unidadeNome) {
        document.getElementById('funcaoAtual').value = funcaoAtiva.unidadeNome + ' - ' + funcaoAtiva.funcaoNome;
      }

      this.form.grauEscolaridade = form.grauEscolaridade;
      this.form.estadoCivil = form.estadoCivil;

      // endereço
      if (form.endereco) {
        if (form.endereco.logradouro) {
          this.outForm.logradouro = form.endereco.logradouro;
        }

        if (form.endereco.bairro && form.endereco.bairro.id) {
          this.outForm.setor = form.endereco.bairro.nome;
        } else {
          this.outForm.setor = form.endereco.bairro;
        }

        if (form.endereco.municipio && form.endereco.municipio.id) {
          this.outForm.cidade = form.endereco.municipio.nome;
          this.outForm.uf = form.endereco.municipio.uf;
        } else {
          this.outForm.cidade = form.endereco.cidade;
          this.outForm.uf = form.endereco.uf;
        }
        this.outForm.numero = form.endereco.numero;
        this.outForm.complemento = form.endereco.complemento;
        this.outForm.lote = form.endereco.lote;
        this.outForm.quadra = form.endereco.quadra;

        if (form.endereco.cep) {
          this.outForm.cep = form.endereco.cep;
          this.$refs.cep.value = form.endereco.cep;
        }

        this.form.endereco = this.outForm;
      }

      if (this.form.subEspecialidade && this.form.subEspecialidade.id) {
        await this.getSubEspecialidades(this.form.subEspecialidade.id);
      }

      // documentos
      this.dataDocuments = this.form.documentos;
      //carregar img
      await this.carregarImg(this.form.idAnexoFileImg);
    },
    stringTipoDocumento(documento) {
      let tipoDoc = this.enumTipoDocumento.find((etp) => etp.tipo === documento.tipoDocumento || etp.descricao === documento.tipoDocumento);
      if (tipoDoc) {
        return tipoDoc.descricao;
      }
    },
    async baixarArquivo(document) {
      await downloadDocumentFileWs(document.idAnexoFileWs, document.nomeArquivo);
    },
    async carregarImg(idImg) {
      if (idImg)
        await loadDocumentFileWs(idImg).then(async (img) => {
          document.getElementById('imgFoto').src = await imgToBase64(img);
        });
      else if (this.formSicad.imagem) {
        let imgBlob = convertBase64ToBlob('data:image/jpg;base64,' + this.formSicad.imagem);
        document.getElementById('imgFoto').src = await imgToBase64(imgBlob);
      } else {
        document.getElementById('imgFoto').src = imgDoctor;
      }
    },
  },
};
</script>

<style scoped>
#uploadImg {
  display: none;
}
</style>
